<template>
  <div class="layout-body">
    <navigation>
      <router-view />
    </navigation>
  </div>
</template>

<script>
export default {
  name: "LayoutBody",
};
</script>

<style lang="less">
.layout-body {
  flex: 1;
}
</style>
